var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeatureTileIcon04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.331 30.493l-4.685 7.001M49.236 32.831l-10.419-3.803M49.84 36.08L39.16 46.921M51.597 36.971l-1.28 12.046M30.917 39.305l18.166-4.61",
    stroke: "#29FFFB"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#CDE0FF",
    cx: 28,
    cy: 40,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#CDE0FF",
    cx: 52,
    cy: 34,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#CDE0FF",
    cx: 36,
    cy: 28,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#CDE0FF",
    cx: 37,
    cy: 49,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#CDE0FF",
    cx: 50,
    cy: 52,
    r: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureTileIcon04);
export default __webpack_public_path__ + "static/media/feature-tile-icon-04.7ad0510b46be65d63ba7539c957bf5aa.svg";
export { ForwardRef as ReactComponent };